import aMd from '../content/a.md?raw'
import bMd from '../content/b.md?raw'
import cMd from '../content/c.md?raw'
import dMd from '../content/d.md?raw'
import escalationMd from '../content/escalation.md?raw'
import appendixMd from '../content/appendix.md?raw'
import { GuideSection, GuideVariant, section } from '../core'
import { EscalationContact } from '../components/EscalationContact'

/**
 * 区分は「症状の名前」ではなく「処方箋がどこまで進んだか」で切る。
 * 同一症状に真因が多岐にわたるため、症状→対処のフローは誤誘導になる。
 * 記号と文言は A4シート裏面（Figma）と一致させること。
 *
 * 区分は自己完結させる。目次から各区分・各手順へ直接飛んで読まれるため、
 * 前置き（軸の説明・用語集）は置かず、他の区分の手順番号も参照しない。
 * 同じ手順が複数の区分に要るときは、双方に書き下す。
 * 区分をまたいで読ませるほうが高くつく。
 *
 * 手順の見出しは「確認して分かる事象」だけで書き、対処は本文の1行目に置く。
 * 動詞（「電源ランプを確認する」）で並べると、どれも自分に当てはまるように
 * 見えて、目次が切り分けの役に立たない。見出しがそのまま目次になるので、
 * 目次を上から読む＝切り分けが進む、が成立する。
 * 安い確認から順に並べ、上から読んで最初に当てはまった場所で止める。
 *
 * ただし、これは症状の一覧ではない。同一症状に真因が多岐にわたるのが
 * この領域の性質で（「接続不能」は電源・ケーブル・ドライバのどれでも出る）、
 * 症状から引ける表にすると誤誘導になる。並び順に意味があるので、
 * 手順を入れ替えるときは費用の安い順が崩れていないかを見ること。
 */
export const DEFAULT_SECTIONS: GuideSection[] = [
  // A〜D のタイトルは紙のシート裏面（Figma）と逐語一致させること
  section({
    id: 'a',
    label: 'A',
    title: 'スキャンできない',
    body: aMd,
  }),
  section({
    id: 'b',
    label: 'B',
    title: 'スキャンしたのに まもる君web・レセコンに出ない',
    body: bMd,
  }),
  section({
    id: 'c',
    label: 'C',
    title: 'まもる君web にログインできない',
    body: cMd,
  }),
  section({
    id: 'd',
    label: 'D',
    title: '読み取った内容がちがう',
    body: dMd,
  }),
  section({
    id: 'escalation',
    title: 'それでも解決しないとき',
    body: escalationMd,
  }),
  section({
    id: 'appendix',
    title: '付録',
    body: appendixMd,
  }),
]

/**
 * default = 直販（fi-800R キット・メール窓口）。/guide が持つ。
 * Melphin 取次（ウエルシア以外の販売パートナー経由）の店舗もこの版に着く。
 * 配布物は QuickSync と証明書だけで、AutoScanHelper は入らない（セットアップ手順書
 * 「まもる君と Kakeru君 のセットアップ手順」）。そのため A・B から立ち上げ直しの手順を
 * 落とし、「接続不能」ダイアログと「ソースの選択」も持たない（どちらも AutoScanHelper
 * の画面）。AutoScanHelper のある版は variants/welcia が持つ。
 * 連絡先は直販の窓口（support@ へのメール）。どの店舗がこの版に着くかは back が
 * 法人から決める（hub design-book ADR-0051）。
 */
export const defaultVariant: GuideVariant = {
  sections: DEFAULT_SECTIONS,
  contact: <EscalationContact />,
}
